// extracted by mini-css-extract-plugin
export default {"container":"Ota-z","oos":"Pta-z","selected":"Qta-z","recommendedSize":"Rta-z"};